import { render, staticRenderFns } from "./PlatformTransferResult.vue?vue&type=template&id=3170ed67&"
import script from "./PlatformTransferResult.vue?vue&type=script&lang=js&"
export * from "./PlatformTransferResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports